import { createContext } from 'react';

type TypeInitialValues = {
  availableChannels: any,
  urlRedirect: any,
  setUrlRedirect: (value: (((prevState: string) => string) | string)) => void,

}

const initialValues: TypeInitialValues = {
  availableChannels: null,
  urlRedirect: '',
  setUrlRedirect: () => {},
};

const AppContext = createContext(initialValues);

export default AppContext;
